module.exports = __webpack_public_path__ + "img/feature_buy_th.40e779f2.png";